<template>
  <form class="form">
    <div class="inputs">
      <TagCustomColorPicker
        :selected-color="newTagProps.color"
        @colorSelected="handleColorSelected"
      />
      <TagFormPicker
        :selected-form="newTagProps.form"
        @formSelected="handleFormSelected"
      />
      <div class="form-group custom-form-group">
        <label class="form-control-label"> Название </label>
        <input
          :style="{ color: errorLabel ? '#fe2712' : '#263239' }"
          type="text"
          class="form-control form-control-light custom-form-input"
          placeholder="Название метки"
          v-model="newTagProps.name"
          @input="validateLabel"
        />
        <span v-if="errorLabel" class="text-input-error">{{ errorLabel }}</span>
      </div>
    </div>

    <div class="second-block">
      <button
        :disabled="(!!errorLabel || tags.length >= 10) && !editTagId"
        @click.prevent="handleSaveTag"
        class="btn btn-middle add-tag-btn"
      >
        Сохранить
      </button>

      <div class="maxTagsError" v-if="tags.length === 10">
        Вы достигли максимального количества меток (10)
      </div>
    </div>

    <TagList
      :editTagId="editTagId"
      :newTagProps="newTagProps"
      @editTag="handleEditTag"
      @deleteTag="handleDeleteTag"
    />

    <div class="helpMessage">
      <Arrows width="16" height="16" fill="#7D919B" />
      <span>
        Перетягивая метки, вы можете изменить порядок их отображения в сервисе.
      </span>
    </div>

    <TagDeleteNotification
      v-if="isOpenDeleteDialog"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
      :lotsCount="lotsCount"
    />
  </form>
</template>

<script>
import TagCustomColorPicker from "./TagCustomColorPicker.vue";
import TagFormPicker from "./TagFormPicker.vue";
import TagList from "./TagList.vue";
import TagDeleteNotification from "./TagDeleteNotification.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Arrows from "@/assets/icons/arrows.svg";

export default {
  name: "TagEditorModal",
  components: {
    TagCustomColorPicker,
    TagFormPicker,
    TagList,
    TagDeleteNotification,
    Arrows,
  },
  data() {
    return {
      newTagProps: {
        color: "",
        form: "",
        label: "",
      },
      editTagId: null,
      errorLabel: "",
      deleteTagId: null,
      lotsCount: 0,
      isOpenDeleteDialog: false,
    };
  },
  computed: {
    ...mapGetters("tags", ["tags", "colors", "forms"]),
    ...mapGetters("profile", ["profileId"]),
  },
  created() {
    this.setInitialNewTagProps();
  },
  methods: {
    ...mapMutations("tags", ["ADD_TAG", "EDIT_TAG", "DELETE_TAG"]),
    ...mapActions("tags", ["createTag", "editTag", "deleteTag"]),
    ...mapActions("filterTabs", ["getFilterTabs"]),

    setInitialNewTagProps() {
      this.newTagProps.color = this.colors?.[0];
      this.newTagProps.form = this.forms?.[0]?.name;
      this.newTagProps.name = "";
    },

    resetNewTagProps() {
      this.setInitialNewTagProps();
      this.errorLabel = "";
      this.editTagId = null;
    },

    handleColorSelected(color) {
      this.newTagProps.color = color;
    },

    handleFormSelected(form) {
      this.newTagProps.form = form;
    },

    validateLabel() {
      if (this.newTagProps.name.length > 20) {
        this.errorLabel = "Поле должно содержать не более 20 символов";
        return false;
      }
      this.errorLabel = "";
      return true;
    },

    async handleSaveTag() {
      if (!this.validateLabel()) return;

      if (this.editTagId) {
        this.editTag({
          tagId: this.editTagId,
          tagData: {
            ...this.newTagProps,
            profileId: this.profileId,
          },
        });
        this.editTagId = null;
      } else {
        await this.createTag({
          ...this.newTagProps,
          profileId: this.profileId,
        });
        await this.getFilterTabs(this.profileId);
      }

      this.resetNewTagProps();
    },

    handleEditTag(id) {
      if (id) {
        this.editTagId = id;
        const tag = this.tags.find((tag) => tag.id === id);
        this.newTagProps = { ...tag };
      } else {
        this.editTagId = null;
        this.resetNewTagProps();
      }
    },
    handleDeleteTag(id, lotCount) {
      this.resetNewTagProps();
      if (lotCount === 0) {
        this.deleteTag(id);
      } else {
        this.deleteTagId = id;
        this.lotsCount = lotCount;
        this.isOpenDeleteDialog = true;
      }
    },

    confirmDelete() {
      this.handleDeleteTag(this.deleteTagId, 0);
      this.cancelDelete();
    },
    cancelDelete() {
      this.isOpenDeleteDialog = false;
      this.deleteTagId = null;
      this.lotsCount = 0;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;

  .inputs {
    display: flex;
    flex-direction: row;
    gap: 13px;
    width: calc(100% - 64px);
    margin: 0 32px;

    .custom-form-group {
      position: relative;
      width: 100%;
      margin: 0;

      .custom-form-input {
        padding-left: 12px !important;
        padding-right: 12px !important;
      }

      .text-input-error {
        position: absolute;
        bottom: -18px;
        right: 0px;
        font-weight: 400;
        font-style: Regular;
        font-size: 11px;
        line-height: 20px;
        color: #fe2712;
      }
    }
  }

  .second-block {
    display: flex;
    gap: 13px;
    margin: 0 32px;

    .add-tag-btn {
      min-width: 153px;
      width: 153px;
      height: 44px;
      padding: 0;
    }

    .maxTagsError {
      display: flex;
      align-items: center;
      background-color: #ffe5e5;
      color: #fe2712;
      width: 100%;
      height: 44px;
      padding: 10px 15px;
      border-radius: 4px;
    }
  }

  .helpMessage {
    margin: 0 32px;
    display: flex;
    gap: 10px;
    font-weight: 400;
    font-size: 14px;
    color: #7d919b;
  }
}
</style>
